// removed by extract-text-webpack-plugin
module.exports = {"WheelContainer":"WheelDown__WheelContainer__-hash-base-64-5-","Wheel_1":"WheelDown__Wheel_1__-hash-base-64-5-","wheel":"WheelDown__wheel__-hash-base-64-5-","Wheel_2":"WheelDown__Wheel_2__-hash-base-64-5-","Wheel_3":"WheelDown__Wheel_3__-hash-base-64-5-","Wheel_4":"WheelDown__Wheel_4__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/WheelDown/WheelDown.scss
// module id = 192
// module chunks = 0